module.exports = __webpack_public_path__ + "img/lock.6393c2d1.png";